import EditFleetView from "../../components/EditFleetView";

EditFleetScreen.propTypes = {};

function EditFleetScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="my-4">
                <EditFleetView />
            </div>
        </div>
    );
}

export default EditFleetScreen;
